export default "__VITE_PUBLIC_ASSET__15664c53__"